import { Modal } from 'antd';

const TrackOrderIframeModal = ({
  isTrackingModalOpen,
  setIsTrackingModalOpen,
  trackingUrl,
}) => (
  <Modal
    title="Track Order"
    open={isTrackingModalOpen}
    onCancel={() => setIsTrackingModalOpen(false)}
    footer={null}
    width="80dvw"
    centered
  >
    <iframe
      src={trackingUrl}
      style={{
        width: '100%',
        height: '80vh',
        border: 'none',
        borderRadius: '8px',
      }}
      title="Order Tracking"
    />
  </Modal>
);

export default TrackOrderIframeModal;
